// import { Icon } from "@iconify/react/dist/iconify.js";
// import React, { useState, useEffect } from "react";
// import NavChart from "./NavChart";
// import axios from "axios";

// const SalesStatisticOne = () => {
//   const NavUrl = process.env.REACT_APP_NAV_BASE_URL;
//   const NavAPIKey = process.env.REACT_APP_NAV_API_KEY;

//   const [timePeriod, setTimePeriod] = useState("1M");
//   const [latestNav, setLatestNav] = useState(null);
//   const [returnPercentage, setReturnPercentage] = useState(null);


//   useEffect(() => {
//     // API call to fetch NAV data
//     axios
//       .get(`${NavUrl}/nav-history`, {
//         headers: {
//           Authorization: `${NavAPIKey}`,
//         },
//       })
//       .then((response) => {
//         // Assuming the data is in response.data.data
//         const latestNavData = response.data.data[0];
//         setLatestNav(latestNavData.current_nav);
//       })
//       .catch((error) => {
//         console.error("Error fetching NAV data:", error);
//       });
//   }, []); 

 

//   return (
//     <div className="col-xxl-8 col-xl-12">
//       <div className="card h-100">
//         <div className="card-body">
//           <div className="d-flex flex-wrap align-items-center justify-content-between">
//             <h6 className="text-lg mb-0">NAV Growth</h6>

//             <div className="d-flex gap-2">
//               <select className="form-select bg-base form-select-sm w-auto" value={timePeriod} onChange={(e) => setTimePeriod(e.target.value)}>
//                 <option value="All">All</option>
//                 <option value="5Y">5 Year</option>
//                 <option value="3Y">3 Year</option>
//                 <option value="1Y">1 Year</option>
//                 <option value="6M">6 Month</option>
//                 <option value="1M">1 Month</option>
//               </select>
//             </div>
//           </div>

//           <div className="d-flex flex-wrap align-items-center gap-2 mt-8">
//             <h6 className="mb-0">${latestNav}</h6>

//             <span className={`text-sm fw-semibold rounded-pill ${returnPercentage >= 0 ? 'bg-success-focus text-success-main' : 'bg-danger-focus text-danger-main'} border br-success px-8 py-4 line-height-1 d-flex align-items-center gap-1`}>
//               {returnPercentage && (
//                 <>
//                   {returnPercentage >= 0 ? `(+${returnPercentage}%)` : `(-${returnPercentage}%)`}
//                   <Icon icon={returnPercentage >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} className="text-xs" />
//                 </>
//               )}
//             </span>

//             <span className="text-xs fw-medium">{timePeriod}</span>
//           </div>

//           <NavChart timePeriod={timePeriod} NavUrl={NavUrl} NavAPIKey={NavAPIKey} setReturnPercentage={setReturnPercentage} height={264} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesStatisticOne;

import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import NavChart from "./NavChart";
import PortfolioChart from "./PortfolioChart";
import axios from "axios";
import { jwtDecode } from "jwt-decode";


const SalesStatisticOne = () => {
  const NavUrl = process.env.REACT_APP_NAV_BASE_URL;
  const NavAPIKey = process.env.REACT_APP_NAV_API_KEY;

  const [chartType, setChartType] = useState("NAV Growth");
  const [timePeriod, setTimePeriod] = useState("1M");
  const [latestNav, setLatestNav] = useState(null);
  const [navHistory, setNavHistory] = useState(null);
  const [returnPercentage, setReturnPercentage] = useState(null);

  

  useEffect(() => {
    if (chartType === "NAV Growth") {
      axios
        .get(`${NavUrl}/nav-history`, {
          headers: {
            Authorization: `${NavAPIKey}`,
          },
        })
        .then((response) => {
          const latestNavData = response.data.data[0];
          setLatestNav(latestNavData.current_nav);
          setNavHistory(response.data);
        })
        .catch((error) => {
          console.error("Error fetching NAV data:", error);
        });
    } else if (chartType === "Portfolio Growth") {
      axios
      .get(`${NavUrl}/nav-history`, {
        headers: {
          Authorization: `${NavAPIKey}`,
        },
      })
      .then((response) => {
        const latestNavData = response.data.data[0];
        setLatestNav(latestNavData.current_nav);
        setNavHistory(response.data);
      })
      .catch((error) => {
        console.error("Error fetching NAV data:", error);
      });
    }
  }, [chartType]);

  const [investmentData, setInvestmentData] = useState([]);
  const BaseUrl = process.env.REACT_APP_API;

  const getTokenFromLocalStorage = () => sessionStorage.getItem("authToken");

  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.company_id || null;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = getTokenFromLocalStorage();
      
        const company_id = decodeToken(token);
   
        const investmentResponse = await axios.get(`${BaseUrl}/getInvestmentsByID`, {
          params: { company_id },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (investmentResponse.status === 200) {
          setInvestmentData(investmentResponse.data || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [BaseUrl]);

  return (
    <div className="col-xxl-8 col-xl-12">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <h6 className="text-lg mb-0">{chartType}</h6>

            <div className="d-flex gap-2">
            

              <select
                className="form-select bg-base form-select-sm w-auto"
                value={timePeriod}
                onChange={(e) => setTimePeriod(e.target.value)}
                hidden={chartType === "Portfolio Growth"}
              >
                <option value="All">All</option>
                <option value="5Y">5 Year</option>
                <option value="3Y">3 Year</option>
                <option value="1Y">1 Year</option>
                <option value="6M">6 Month</option>
                <option value="1M">1 Month</option>
              </select>

              <select
                className="form-select bg-base form-select-sm w-auto"
                value={chartType}
                onChange={(e) => setChartType(e.target.value)}
              >
                <option value="NAV Growth">NAV Growth</option>
                <option value="Portfolio Growth">Portfolio Growth</option>
              </select>
            </div>
          </div>

          {chartType === "NAV Growth" && (
            <div className="d-flex flex-wrap align-items-center gap-2 mt-8">
              <h6 className="mb-0">${latestNav}</h6>

              <span
                className={`text-sm fw-semibold rounded-pill ${
                  returnPercentage >= 0
                    ? "bg-success-focus text-success-main"
                    : "bg-danger-focus text-danger-main"
                } border br-success px-8 py-4 line-height-1 d-flex align-items-center gap-1`}
              >
                {returnPercentage && (
                  <>
                    {returnPercentage >= 0
                      ? `(+${returnPercentage}%)`
                      : `(-${returnPercentage}%)`}
                    <Icon
                      icon={
                        returnPercentage >= 0
                          ? "bxs:up-arrow"
                          : "bxs:down-arrow"
                      }
                      className="text-xs"
                    />
                  </>
                )}
              </span>

              <span className="text-xs fw-medium">{timePeriod}</span>
            </div>
          )}

          

          {chartType === "NAV Growth" && (
            <NavChart
              timePeriod={timePeriod}
              NavUrl={NavUrl}
              NavAPIKey={NavAPIKey}
              setReturnPercentage={setReturnPercentage}
              height={264}
            />
          )}

          {chartType === "Portfolio Growth" && (
            // <PortfolioChart timePeriod={timePeriod} height={264} />
            <PortfolioChart 
            investmentData={investmentData}
            navHistory ={navHistory}
            timePeriod={timePeriod}
            NavUrl={NavUrl}
            NavAPIKey={NavAPIKey}
            setReturnPercentage={setReturnPercentage}
          />
          
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesStatisticOne;